import _ from 'lodash';

// just grabbing the global variable for now
export const featureFlagService = {
	keys: (): string[] =>
		_.get(window, 'lt.features', [])
			.filter((flag: { enabled: boolean }) => flag.enabled)
			.map((flag: { featureId: string }) => flag.featureId),
	isEnabled: (key: string): boolean => _.includes(featureFlagService.keys(), key)
};
